import classnames from 'classnames';
import React, { useContext } from 'react';
import styled, { ThemeContext, ThemeProvider } from 'styled-components';
import { LoaderLabelPositions, LoaderSizes, LoaderLooks } from '../../../../enums/loader.js';
import '../../../../styles/styled-components/alert.js';
import '../../../../styles/styled-components/animations.js';
import '../../../../styles/styled-components/box-shadow.js';
import '../../../../styles/styled-components/button.js';
import '../../../../themes/alert.js';
import '../../../../themes/button.js';
import '../../../../themes/checkbox.js';
import '../../../../themes/divider.js';
import '../../../../themes/dropdown.js';
import '../../../../themes/fieldset.js';
import { fontFamilyBook } from '../../../../themes/fonts.js';
import '../../../../themes/input.js';
import '../../../../themes/list.js';
import '../../../../themes/listbox.js';
import '../../../../themes/loader.js';
import '../../../../themes/option.js';
import '../../../../themes/popout.js';
import '../../../../themes/switch.js';
import { lightTheme } from '../../../../themes/themes.js';
import '../../../../themes/tooltip.js';
import '../../../../styles/styled-components/font-face.js';
import '../../../../styles/styled-components/global.js';
import '../../../../styles/styled-components/input.js';
import '../../../../styles/styled-components/list.js';
import '../../../../styles/styled-components/listitem.js';
import { getLoaderPosition, getLoaderSize, getLoaderTheme, getLoaderRotate, getLoaderStroke, getLoaderStretch } from '../../../../styles/styled-components/loader.js';
import '../../../../styles/styled-components/media-queries.js';
import '../../../../styles/styled-components/reset.js';
import '../../../../styles/styled-components/outline.js';
import '../../../../styles/styled-components/popout.js';
import '../../../../styles/styled-components/screen-reader.js';
import '../../../../styles/styled-components/switch.js';
import '../../../../styles/styled-components/tooltip.js';
import { BaseLoader } from '../base-loader/base-loader.js';

const BaseCircleLoader = (props)=>{
    const { buttonLook, className, label, labelPosition = LoaderLabelPositions.Right, labelProps, look, showLabel = false, size = LoaderSizes.Medium, svgCircleProps, svgProps, ...otherProps } = props;
    return /*#__PURE__*/ React.createElement(BaseLoader, {
        ...otherProps,
        "aria-label": showLabel ? undefined : label,
        "aria-hidden": buttonLook && !label ? true : undefined,
        className: classnames({
            'bf-loader__circle': true,
            [`bf-loader__circle--label-${labelPosition}`]: labelPosition,
            [`bf-loader__circle--look-${look}`]: look,
            [`bf-loader__circle--size-${size}`]: size,
            [`${className}`]: !!className
        })
    }, /*#__PURE__*/ React.createElement("svg", {
        ...svgProps,
        "aria-hidden": true,
        className: classnames({
            'bf-loader__svg': true,
            [`${svgProps?.className}`]: !!svgProps?.className
        }),
        viewBox: "25 25 50 50",
        role: "img"
    }, /*#__PURE__*/ React.createElement("circle", {
        ...svgCircleProps,
        className: classnames({
            'bf-loader__svg-circle': true,
            [`${svgCircleProps?.className}`]: !!svgCircleProps?.className
        }),
        cx: "50",
        cy: "50",
        r: "20"
    })), showLabel && /*#__PURE__*/ React.createElement("span", {
        ...labelProps,
        className: classnames({
            'bf-loader__label': true,
            [`${labelProps?.className}`]: !!labelProps?.className
        })
    }, label));
};
const Loader = styled(BaseCircleLoader)`
  ${({ labelPosition, size })=>getLoaderPosition({
        labelPosition,
        size
    })}
  ${({ size })=>getLoaderSize({
        size
    })}
  ${({ buttonLook, look })=>getLoaderTheme({
        buttonLook,
        look
    })}
  align-items: center;
  box-sizing: border-box;
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: center;
  overflow: hidden;
  width: 100%;

  .bf-loader__label {
    font-family: ${fontFamilyBook};
    max-width: 300px;
  }

  .bf-loader__svg {
    animation: ${getLoaderRotate()} 2s linear infinite;
    flex-shrink: 0;
    transform-origin: center;
  }

  .bf-loader__svg-circle {
    fill: transparent;
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
    stroke-linecap: round;
    stroke-width: 5px;
    animation:
      ${({ look, theme })=>getLoaderStroke({
        look,
        theme
    })} 3s cubic-bezier(1, 0, 0, 1) infinite,
      ${getLoaderStretch()} 1.5s ease-in-out infinite;
  }
`;
const CircleLoader = (props)=>{
    const { look = LoaderLooks.Primary, ...otherProps } = props;
    const themeContext = useContext(ThemeContext);
    return /*#__PURE__*/ React.createElement(ThemeProvider, {
        theme: themeContext || lightTheme
    }, /*#__PURE__*/ React.createElement(Loader, {
        look: look,
        ...otherProps
    }));
};

export { CircleLoader };
//# sourceMappingURL=circle-loader.js.map
